import _ from 'lodash';
import template from './contract.html';
import AbstractSectionController from '../AbstractSectionController';

const modalTemplate = '<fp-documents-content-modal data-on-close="$dismiss()" data-title="{{$ctrl.title}}" data-url="{{$ctrl.url}}"></fp-documents-content-modal>';

class ContractController extends AbstractSectionController {
    /*@ngInject*/
    constructor($uibModal, $window, constants, dataContext, pluginService, mobileAppContext) {
        super();
        this.$uibModal = $uibModal;
        this.mobileAppContext = mobileAppContext;
        this.$window = $window;
        this.constants = constants;
        this.dataContext = dataContext;
        this.pluginService = pluginService;
    }

    inMobileApp() {
        return this.mobileAppContext.get();
    }

    canViewPdfInBrowser() {
        return this.pluginService.hasAXPlugin(this.$window.navigator.plugins);
    }

    openModal() {
        const captureCtx = this;

        this.$uibModal.open({
            template: modalTemplate,
            controllerAs: '$ctrl',
            controller: /*@ngInject*/ function() {
                this.title = 'Contract';
                this.url = captureCtx.getUri();
            },
            size: 'lg'
        });
    }

    getUri() {
        let token = this.dataContext.user.loadAccessToken();
        if (_.isNil(token)) {
            token = '';
        }

        token = token.replace(/"/g, '');

        return `/api/document/ContractRawFile?token=${token}`;
    }
}

export default {
    template: template,
    bindings: {
        contract: '<',
        isLoading: '<'
    },
    controller: ContractController
};